import styled from 'styled-components';

import { Media } from '../../assets/Mixins.style';

import { Strong as commonStrong } from '../../assets/Common/Strong.style';

export const Box = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;

  ${Media.lg`
    display: inline;
    width: initial;
  `}
`;

export const Column = styled.div`
  display: block;

  ${Media.lg`
    display: inline;
  `}
`;

export const Strong = styled.strong`
  ${commonStrong}
`;
